import { Entity, IEntity } from "./Entity";
import { IGoDefElementOrgLevel1 } from "./GoDefElementOrgLevel1";

export interface IGoDefElement extends IEntity {
    Instructions?: string;
    FullInstructions?: string;
    RagRatingStyle?: number;
    OrgLevel1Filter?: number;
    GoDefElementOrgLevel1s?: IGoDefElementOrgLevel1[];
}

export class GoDefElement extends Entity implements IGoDefElement {
    public Instructions?: string = null;
    public FullInstructions?: string = null;
    public RagRatingStyle?: number = null;
    public OrgLevel1Filter?: number = null;

    constructor() {
        super();
        this.OrgLevel1Filter = 0; //default value
    }
}